import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments';
import { TreatmentSubTypeModel } from '../models';
import { Observable } from 'rxjs';

const basePath = `${environment.apiBaseUrl}treatment-sub-type`;

@Injectable({ providedIn: 'root' })
export class TreatmentSubTypeApiClient {
    private readonly _http = inject(HttpClient);

    getRegionListOptions(parentId?: number): Observable<TreatmentSubTypeModel[]> {
        return this._http.get<TreatmentSubTypeModel[]>(
            `${basePath}/region-list-options${parentId ? `/${parentId}` : ''}`
        );
    }
}
